module.exports = __webpack_public_path__ + "img/u14.b230a7c9.png";